export default {
  login: {
    title: 'Tabbio',
    heading: 'تسجيل الدخول أو إنشاء حساب',
    subtitle: 'ستحصل على إجابات أذكى ويمكنك رفع الملفات والصور والمزيد.',
    emailPlaceholder: 'البريد الإلكتروني',
    passwordPlaceholder: 'كلمة المرور',
    continue: 'متابعة',
    legalPrefix: 'بالمتابعة، فإنك توافق على',
    legalAnd: 'وتقرّ بالاطلاع على',
    termsLink: 'شروط الخدمة',
    privacyLink: 'سياسة الخصوصية',
    or: 'أو',
    orContinueWithEmail: 'أو المتابعة بالبريد الإلكتروني',
    back: 'رجوع',
    methodTitle: 'مرحباً بعودتك',
    methodSubtitle: 'وجدنا حساباً مرتبطاً بـ {{email}}. اختر طريقة المتابعة.',
    continueWithPassword: 'استخدام كلمة المرور',
    continueWithOtp: 'إرسال رمز إلى البريد',
    passwordTitle: 'أدخل كلمة المرور',
    accountFoundTitle: 'وجدنا حسابك في Tabbio',
    accountFoundBody:
      'هذا البريد الإلكتروني مسجّل بحساب بالفعل. سجّل الدخول وستُضاف سيرتك الذاتية المستوردة إليه. تريد حساباً منفصلاً؟ اختر "استخدام بريد آخر" في الأعلى.',
    passwordSubtitle: 'سجّل الدخول باستخدام كلمة مرور هذا الحساب.',
    otpTitle: 'تحقق من بريدك',
    otpSubtitle: 'أدخل رمز الدخول المكوّن من 6 أرقام الذي أرسلناه إلى {{email}}.',
    otpPlaceholder: '123456',
    verifyCode: 'تأكيد الرمز',
    resendCode: 'إعادة إرسال الرمز',
    resendCodeIn: 'إعادة الإرسال خلال {{seconds}} ث',
    useEmailCode: 'استخدام رمز البريد بدلاً من ذلك',
    signupTitle: 'أنشئ حسابك',
    signupSubtitle: 'أكمل إعداد {{email}} بمعلوماتك الأساسية.',
    signupOtpTitle: 'تحقق من بريدك',
    signupOtpSubtitle: 'أدخل الرمز المكوّن من 6 أرقام الذي أرسلناه إلى {{email}} لإكمال إنشاء الحساب.',
    createAccount: 'إنشاء الحساب',
    useAnotherEmail: 'استخدام بريد آخر',
    socialError: 'تعذر المتابعة باستخدام {{provider}} الآن.',
    accountNotLinked:
      'هذا الحساب موجود بالفعل بطريقة تسجيل دخول مختلفة. سجّل الدخول بالطريقة التي أنشأت بها الحساب، ثم اربط هذه الطريقة من الإعدادات › الحساب.',
    emailValidationError: 'أدخل بريداً إلكترونياً صحيحاً.',
    emailCheckError: 'تعذر التحقق من البريد الإلكتروني الآن.',
    accountUnavailable: 'هذا الحساب غير متاح لتسجيل الدخول.',
    accountDeleted: 'تم حذف هذا الحساب ولا يمكن استخدامه لتسجيل الدخول.',
    partnerAccountNotice:
      'لديك حساب شريك. يمكنك إدارته من partners.tabbio.com، أو متابعة تسجيل الدخول من هنا.',
    bootstrapCheckTitle: 'نحتاج إلى التحقق من طرق تسجيل الدخول الخاصة بك',
    bootstrapCheckSubtitle: 'تعذر تأكيد الحسابات المرتبطة بك حالياً. أعد المحاولة قبل دخول التطبيق.',
    bootstrapCheckRetry: 'إعادة المحاولة',
    bootstrapCheckLoading: 'جارٍ التحقق من حسابك…',
    bootstrapPasswordTitle: 'أنشئ كلمة مرورك',
    bootstrapPasswordSubtitle: 'أضف كلمة مرور إلى {{email}} حتى تتمكن من تسجيل الدخول بدون رمز في المرة القادمة.',
    bootstrapPasswordPlaceholder: 'كلمة المرور الجديدة',
    bootstrapPasswordConfirmPlaceholder: 'تأكيد كلمة المرور',
    bootstrapPasswordSubmit: 'حفظ كلمة المرور',
    bootstrapPasswordMismatch: 'كلمتا المرور غير متطابقتين.',
    bootstrapPasswordError: 'تعذر حفظ كلمة المرور الآن.',
    passwordRequired: 'أدخل كلمة المرور للمتابعة.',
    passwordValidationError: 'اختر كلمة مرور أقوى.',
    passwordSignInError: 'تعذر تسجيل الدخول بكلمة المرور هذه.',
    otpSendError: 'تعذر إرسال رمز تسجيل الدخول الآن.',
    otpRequired: 'أدخل الرمز المكوّن من 6 أرقام الذي أرسلناه إلى بريدك.',
    otpSignInError: 'هذا الرمز غير صحيح. حاول مرة أخرى أو أعد إرساله.',
    otpTooManyAttempts: 'محاولات كثيرة. اطلب رمزًا جديدًا.',
    otpLocked: 'محاولات تحقق كثيرة. حاول مرة أخرى بعد 15 دقيقة.',
    otpResendCooldown: 'انتظر قليلًا قبل طلب رمز آخر.',
    nameRequired: 'أضف اسمك لإنشاء الحساب.',
    usernameValidationError: 'اختر اسم مستخدم صالحاً.',
    signupError: 'تعذر إنشاء حسابك الآن.',
    accountCreated: 'تم إنشاء الحساب',
    signInSuccess: 'تم تسجيل الدخول بنجاح',
    authSyncRetryMessage: 'تعذر إكمال تسجيل الدخول. حاول مرة أخرى.',
    appleUnavailableError: 'تسجيل الدخول عبر Apple غير متاح على هذا الجهاز.',
    appleTokenError: 'تعذر قراءة رمز هوية Apple.',
    continueGoogle: 'المتابعة مع Google',
    continueApple: 'المتابعة مع Apple',
    continueUaePass: 'المتابعة مع الهوية الرقمية',
    heroBase: 'أنشئ سيرتك الذاتية الرقمية',
    heroAccent: 'في ثوانٍ.',
    heroSubtitle: 'يجد الوظائف ويكيّف سيرتك الذاتية ويتقدم عنك ويخبرك عند رد أصحاب العمل.',
    moreOptions: 'خيارات أخرى',
    continueEmail: 'المتابعة بالبريد الإلكتروني',
    languageLabel: 'اللغة',
    languagePlaceholder: 'اختر اللغة',
    authCompleteStatus: 'جارٍ إكمال تسجيل الدخول',
    noAccount: 'ليس لديك حساب؟ سجّل الآن',
    signIn: 'تسجيل الدخول',
  },

  uaePass: {
    brandName: 'تابيو',
    signInButton: 'تسجيل الدخول بالهوية الرقمية',
    linkChoiceTitle: 'هل لديك حساب إلكتروني مع تابيو؟',
    linkChoiceTitleBeforeBrand: 'هل لديك حساب إلكتروني \n مع',
    yes: 'نعم*',
    no: 'لا**',
    noteLabel: 'ملاحظة:',
    note: 'هذه عملية لمرة واحدة، وستكون عمليات تسجيل الدخول المستقبلية عبر الهوية الرقمية سلسة.',
    linkExistingHelp:
      'سيتم ربط حساب الهوية الرقمية الخاص بك بملف تابيو الحالي',
    linkCreateHelp:
      'سيتم إنشاء ملف تابيو الخاص بك بناءً على حساب الهوية الرقمية',
    existingAccountRequired:
      'يوجد حساب تابيو لهذا الملف في الهوية الرقمية. يرجى اختيار نعم لربطه.',
    linkingTitle: 'ربط ملف تابيو مع الهوية الرقمية',
    linkingSubtitle: '(سجّل الدخول باستخدام بيانات اعتماد تابيو)',
    linkExistingCtaWeb: 'ربط الحساب بالهوية الرقمية',
    linkExistingCtaNative: 'ربط الحساب بالهوية الرقمية',
    matchingEmailRequired:
      'يرجى إدخال نفس البريد الإلكتروني المقدم من الهوية الرقمية لمتابعة الربط.',
    emailPlaceholder: 'yourname@email.com',
    noAccountFound: 'لم يتم العثور على حساب تابيو لهذا البريد الإلكتروني.',
    checkEmailTitle: 'تحقق من بريدك الإلكتروني',
    checkEmailBody: 'أرسلنا رمزاً مكوناً من 6 أرقام إلى',
    verifyLinkCta: 'تحقق واربط',
    registrationTitle: 'إكمال التسجيل',
    registrationBody:
      'تم تعبئة ملفك مسبقاً ببيانات الهوية الرقمية الموثقة. يرجى إكمال الحقول المتبقية أدناه.',
    createAccountCta: 'إنشاء الحساب',
    welcomeTitle: 'مرحباً بك في تابيو',
    welcomeBody: 'تم إنشاء ملفك باستخدام بيانات الهوية الرقمية الموثقة',
    welcomeCta: 'متابعة إعداد ملفك',
    verifiedSectionTitle: 'بيانات الهوية الرقمية الموثقة',
    visitorBadge: 'زائر موثق',
    visitorDescription:
      'تم التحقق من هذا الملف في الهوية الرقمية كزائر، ويتضمن بيانات الزائر المطلوبة من الهوية الرقمية.',
    readOnlyNote: 'بيانات الهوية الرقمية للقراءة فقط ولا يمكن تعديلها',
    unlinkTitle: 'إلغاء ربط الهوية الرقمية؟',
    unlinkBody:
      'ستتم إزالة ربط الهوية الرقمية الموثق من حساب تابيو هذا. يمكنك ربطه مرة أخرى لاحقاً.',
    fieldLabels: {
      fullName: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      gender: 'الجنس',
      mobile: 'رقم الهاتف',
      nationality: 'الجنسية',
      profileType: 'نوع الملف',
      unifiedId: 'الرقم الموحد',
    },
    errors: {
      authFailed: 'حدث خطأ ما أثناء تسجيل الدخول، يُرجى المحاولة مرة أخرى لاحقًا!',
      cancelled: 'قام المستخدم بإلغاء تسجيل الدخول',
      sop1:
        'أنت غير مؤهل للوصول إلى هذه الخدمة. إما أن حسابك لم تتم ترقيته أو أن لديك حساب زائر. يُرجى التواصل مع شركة تابيو للتكنولوجيا لتمكين من الوصول إلى الخدمة.',
      sop2:
        'توقيعك الرقمي في الهوية الرقمية الحالي لا يسمح باستخدام هذه الخدمة, يرجى ترقية حسابك حسب التعليمات على تطبيق الهوية الرقمية.',
      ineligible:
        'أنت غير مؤهل للوصول إلى هذه الخدمة. إما أن حسابك لم تتم ترقيته أو أن لديك حساب زائر. يُرجى التواصل مع شركة تابيو للتكنولوجيا لتمكين من الوصول إلى الخدمة.',
      stateFailed: 'حدث خطأ ما أثناء تسجيل الدخول، يُرجى المحاولة مرة أخرى لاحقًا!',
      sessionExpired: 'قام المستخدم بإلغاء تسجيل الدخول',
      alreadyLinked:
        'حساب الهوية الرقمية هذا مرتبط بالفعل بحساب تابيو آخر',
      wrongAccount:
        'يرجى تسجيل الدخول باستخدام حساب تابيو المطابق لربط الهوية الرقمية.',
      unlinked: 'تم فصل حساب الهوية الرقمية الخاص بك.',
      alreadyUnlinked: 'الهوية الرقمية غير متصلة بالفعل بهذا الحساب.',
    },
  },

  register: {
    title: 'إنشاء حساب',
    heading: 'أنشئ حسابك',
    subtitle: 'ابدأ ببناء سيرتك الذاتية اليوم.',
    namePlaceholder: 'الاسم الكامل',
    usernamePlaceholder: 'اسم المستخدم',
    emailPlaceholder: 'البريد الإلكتروني',
    passwordPlaceholder: 'كلمة المرور',
    signUp: 'إنشاء حساب',
    hasAccount: 'لديك حساب بالفعل؟ سجّل الدخول',
  },

  passwordField: {
    show: 'إظهار كلمة المرور',
    hide: 'إخفاء كلمة المرور',
    rules: {
      minLength: '٨ أحرف على الأقل',
      hasLetter: 'تحتوي على حرف',
      hasNumber: 'تحتوي على رقم',
      hasSpecial: 'تحتوي على رمز خاص',
    },
  },

  forgotPassword: {
    link: 'هل نسيت كلمة المرور؟',
    title: 'إعادة تعيين كلمة المرور',
    subtitle: 'سنرسل رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.',
    emailPlaceholder: 'البريد الإلكتروني',
    invalidEmail: 'أدخل بريدًا إلكترونيًا صالحًا.',
    sendLink: 'إرسال رابط إعادة التعيين',
    sendError: 'تعذر إرسال رابط إعادة التعيين الآن.',
    sentTitle: 'تحقق من بريدك الإلكتروني',
    sentSubtitle:
      'لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى {{email}}. تحقق من صندوق الوارد واتبع الرابط لإعادة تعيين كلمة المرور.',
    resend: 'إعادة إرسال الرابط',
    resendIn: 'إعادة الإرسال خلال {{seconds}} ث',
  },

  resetPassword: {
    title: 'اختر كلمة مرور جديدة',
    subtitle: 'أدخل كلمة المرور الجديدة أدناه.',
    newPasswordPlaceholder: 'كلمة المرور الجديدة',
    confirmPasswordPlaceholder: 'تأكيد كلمة المرور الجديدة',
    reset: 'إعادة تعيين كلمة المرور',
    mismatch: 'كلمتا المرور غير متطابقتين.',
    invalidToken:
      'رابط إعادة التعيين هذا غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.',
    error: 'تعذر إعادة تعيين كلمة المرور الآن.',
    successTitle: 'تمت إعادة تعيين كلمة المرور',
    successSubtitle:
      'تم تحديث كلمة المرور الخاصة بك. يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة.',
    backToLogin: 'العودة إلى تسجيل الدخول',
  },

  onboarding: {
    getStarted: 'ابدأ الآن',
    next: 'التالي',
    skip: 'تخطي',
    back: 'رجوع',
    done: 'تم',
    completing: 'جارٍ الإعداد…',
    language: 'اللغة',
    cancel: 'إلغاء',
    slides: {
      webcv: {
        title: 'هويتك المهنية',
        subtitle: 'سيرة ذاتية موحدة، ومرجع رقمي معتمد لبياناتك',
      },
      aiAssistant: {
        title: 'متصل في كل مكان',
        subtitle: 'شاركها، نزّلها، أو اربطها مباشرة بأي تطبيق',
      },
      employers: {
        title: 'فرصتك تصل إليك',
        subtitle: 'سيرتك الذاتية تتحدث نيابة عنك وتصل للجهات المناسبة.',
      },
    },
    whereHeard: {
      title: 'من أين سمعت',
      titleAccent: 'عنّا؟',
      promptTitle: 'من أين سمعت عنّا؟',
      promptSubtitle: 'نقرة واحدة تساعدنا في الوصول إلى مزيد من الباحثين عن عمل.',
      options: {
        appStore: 'بحث متجر التطبيقات',
        google: 'بحث جوجل',
        friend: 'توصية صديق',
        social: 'وسائل التواصل الاجتماعي',
        other: 'أخرى',
      },
      otherPlaceholder: 'أخبرنا',
      socialPlatforms: {
        instagram: 'إنستغرام',
        linkedin: 'لينكدإن',
        tiktok: 'تيك توك',
        x: 'إكس (تويتر)',
        youtube: 'يوتيوب',
        facebook: 'فيسبوك',
      },
    },
    whoSeesYou: {
      title: 'أنت تقرّر',
      titleAccent: 'من يراك',
      subtitle: 'خصوصيتك بين يديك. غيّرها متى شئت.',
      showPhoto: 'إظهار صورتي للعامة',
      public: { title: 'عام', subtitle: 'يمكن لمحركات البحث فهرسة سيرتك. تبقى جهات الاتصال مخفية' },
      employers: { title: 'أصحاب العمل فقط', subtitle: 'سيرتك مخفية عن العامة' },
      private: { title: 'خاص تمامًا', subtitle: 'لا شيء مُشارَك' },
    },
    thisIsYou: {
      titleBase: 'هذا',
      titleAccent: 'أنت',
      subtitle: 'اسمك وصورتك ورابط Tabbio الخاص بك',
      photoLabel: 'صورة السيرة الذاتية (اختيارية)',
      photoSublabel: 'للسيرة الذاتية فقط. صورة حسابك مستقلة.',
      hidePhotoPublic: 'إخفاؤها عن العامة',
      fullNameLabel: 'الاسم الكامل',
      verifiedFullNameLabel: 'الاسم الكامل الموثّق',
      cvNameLabel: 'الاسم الظاهر في السيرة الذاتية',
      tabbioLinkLabel: 'رابط Tabbio الخاص بك',
      tabbioLinkPlaceholder: 'الرابط-الخاص-بك',
      stableLinkHelper: 'تم إنشاؤه من اسم سيرتك الذاتية ويبقى ثابتًا عند المشاركة.',
      linkSaveFailed: 'تعذّر حجز الرابط الخاص بك',
      privacyFooter: 'أنت تختار من يرى ماذا.',
      privacyLink: 'الخصوصية',
      cta: 'متابعة',
    },
    enrichment: {
      working: 'جارٍ تحديث سيرتك الذاتية. ستظهر التغييرات هنا تلقائياً.',
    },
    cvStyle: {
      triggerTitle: 'اختر نمط سيرتك الذاتية',
      triggerSub: 'اجعل السيرة مناسبة لمرحلتك المهنية',
      appliedTitle: 'تم اختيار {{style}}',
      appliedSub: 'اضغط لتغيير نمط سيرتك الذاتية',
      applyingTitle: 'جارٍ تطبيق {{style}}',
      applyingSub: 'جارٍ تحديث سيرتك الذاتية',
      failedSub: 'تعذّر تطبيق هذا النمط. اضغط لإعادة المحاولة.',
      sheetTitle: 'اختر نمط سيرتك الذاتية',
      sheetSubtitle: 'اختر الخيار الأقرب لمرحلتك المهنية الحالية.',
      suggestedBadge: 'مقترح',
      useSelectedCta: 'تطبيق النمط',
      savingCta: 'جارٍ حفظ النمط…',
      saveError: 'تعذّر حفظ نمط السيرة الذاتية. حاول مرة أخرى.',
      loadingCta: 'جارٍ الفتح',
      skipCta: 'الإبقاء على السيرة الحالية',
      doneToast: 'تم تطبيق نمط السيرة الذاتية',
      unavailableTitle: 'النمط غير متاح',
      unavailableBody: 'هذا النمط غير متاح الآن. يمكنك المتابعة وتغييره لاحقاً.',
      pickForMeTitle: 'استخدم النمط المقترح',
      pickForMeSub: '{{style}} يناسب ملفك',
      groups: {
        career: 'المرحلة المهنية',
        uae: 'مواطن إماراتي',
        gcc: 'مواطن خليجي',
        expat: 'مقيم',
      },
      segments: {
        'career-fresh': { label: 'بداية المسيرة', desc: 'إبراز التعليم والتدريب ونقاط القوة المبكرة' },
        'career-mid': { label: 'محترف ذو خبرة', desc: 'إبراز التطور المهني والنتائج القابلة للقياس' },
        'career-managerial': { label: 'قيادة', desc: 'إبراز قيادة الفرق والقرارات ونطاق التنفيذ' },
        'career-exec': { label: 'تنفيذي', desc: 'إبراز الاستراتيجية والنطاق والأثر على مستوى المؤسسة' },
        'uae-fresh': { label: 'مواطن إماراتي، خرّيج جديد', desc: 'أول سيرة ذاتية مع إبراز التعليم وملاءمة نافس' },
        'uae-mid': { label: 'مواطن إماراتي، منتصف المسيرة', desc: 'سيرة تقودها الخبرة مع نتائج واضحة' },
        'uae-managerial': { label: 'مواطن إماراتي، مدير', desc: 'قيادة فرق العمل وتحمل المسؤولية والتنفيذ' },
        'uae-exec': { label: 'مواطن إماراتي، تنفيذي', desc: 'استراتيجية ونطاق وتأثير قيادي' },
        'gcc-national': { label: 'مواطن خليجي', desc: 'السعودية أو الكويت أو قطر أو البحرين أو عُمان' },
        'expat-fresh': { label: 'مقيم، خرّيج جديد', desc: 'أول سيرة خليجية مع إبراز المهارات ونقاط القوة' },
        'expat-mid': { label: 'مقيم، منتصف المسيرة', desc: 'سيرة تقودها الخبرة مع نتائج واضحة' },
        'expat-managerial': { label: 'مقيم، مدير', desc: 'قيادة فرق العمل وتحمل المسؤولية والتنفيذ' },
        'expat-exec': { label: 'مقيم، تنفيذي', desc: 'استراتيجية ونطاق وتأثير قيادي' },
      },
    },
    cvPreset: {
      triggerLabel: 'سيرة مخصصة',
      sheetTitle: 'اختر سيرة ذاتية مخصصة',
      sheetSubtitle:
        'من إعداد خبراء التوظيف والمجتمع. كل واحدة تغيّر طريقة كتابة سيرتك الذاتية، قسمًا بقسم.',
      searchPlaceholder: 'ابحث في السير المخصصة',
      searchEmpty: 'لا توجد سير مخصصة مطابقة لبحثك.',
      appliedLabel: 'تم تطبيق {{preset}}',
      changeLabel: 'تغيير',
      removeLabel: 'إزالة السيرة المخصصة',
      applyError: 'تعذر تطبيق هذا النمط. حاول مرة أخرى.',
      presets: {
        'preset-uae-national': {
          label: 'سيرة المواطن الإماراتي',
          desc: 'للإماراتيين. تبدأ بعبارة "مواطن إماراتي" حيث تبحث أنظمة التوطين وجهات التوظيف.',
        },
        'preset-fresh-graduate': {
          label: 'سيرة الخريج الجديد',
          desc: 'للخريجين الجدد المقبلين على سوق العمل في الإمارات.',
        },
        'preset-hr': {
          label: 'سيرة الموارد البشرية',
          desc: 'لمتخصصي الموارد البشرية الباحثين عن أدوار في مختلف القطاعات.',
        },
        'preset-career-switch': {
          label: 'سيرة تغيير المسار المهني',
          desc: 'للمهنيين الراغبين في الانتقال إلى مجال أو قطاع جديد.',
        },
        'preset-relocate-gulf': {
          label: 'سيرة الانتقال إلى الخليج',
          desc: 'للمهنيين الباحثين عن فرص جديدة في دول مجلس التعاون.',
        },
      },
    },
    howToReachYou: {
      titleBase: 'كيف',
      titleAccent: 'نتواصل معك',
      subtitle: 'أنت وأصحاب العمل فقط ترون هذه البيانات',
      emailLabel: 'البريد الإلكتروني',
      emailPlaceholder: 'example@gmail.com',
      emailInvalid: 'أدخل بريدًا إلكترونيًا صحيحًا.',
      phoneLabel: 'رقم الهاتف (اختياري)',
      linksSection: 'الروابط',
      linksSublabel: 'علنية في سيرتك الذاتية',
      linkUsernameError: 'أدخل اسم المستخدم أو الصق رابط ملفك الشخصي.',
      websiteError: 'أدخل موقعاً إلكترونياً، مثال: yoursite.com',
      footerText: 'أنت وأصحاب العمل فقط ترون هذه.',
      howItWorksLink: 'كيف تعمل',
      modalTitle: 'كيف تعمل جهات اتصالك',
      modalRow1Q: 'من يرى بريدك ورقم هاتفك؟',
      modalRow1A: 'أنت وأصحاب العمل فقط. لا يراها الجمهور أبداً',
      modalRow2Q: 'إذاً كيف يتواصل معك الناس؟',
      modalRow2A: 'يراسلونك عبر Tabbio. لا حاجة لرقم',
      modalRow3Q: 'هل يمكنك مشاركتها بنفسك؟',
      modalRow3A: 'نعم. أرسِل رابطاً خاصاً في أي وقت',
      modalDone: 'تم',
      cta: 'متابعة',
    },
    whoSeesCV: {
      recommended: 'موصى به',
      titleBase: 'من يمكنه',
      titleAccent: 'رؤية سيرتك الذاتية',
      subtitle: 'خصوصيتك بين يديك. غيّرها متى شئت',
      footerText: 'أنت المتحكم. يمكنك التغيير في أي وقت.',
      privacyLink: 'الخصوصية',
      publicIndexingConsent:
        'أفهم أن اختيار «عام» ينشئ صفحة Tabbio مفتوحة قد تفهرسها محركات البحث مثل Google، ويمكنني التراجع عن هذا الاختيار في أي وقت.',
      ctaLabel: 'إنشاء السيرة الذاتية',
    },
    basicData: {
      title: 'أضف',
      titleAccent: 'بياناتك الأساسية',
      photoTitle: 'الصورة الشخصية',
      photoHint: 'أضف صورة واضحة واحترافية',
    },
    signOut: 'تسجيل الخروج',
    notifications: {
      titleBase: 'فعّل',
      titleAccent: 'الإشعارات',
      subtitle: 'تذكّر أنه يمكنك إيقافها في أي وقت',
      benefit1: 'الميزة رقم 1 نص مؤقت',
      benefit2: 'الميزة رقم 2 نص مؤقت',
      benefit3: 'الميزة رقم 3 نص مؤقت',
      allow: 'تفعيل الإشعارات',
      maybeLater: 'ربما لاحقًا',
    },
    dataSafe: {
      titleBase: 'بياناتك',
      titleAccent: 'آمنة',
      subtitle: 'اختر كيف يتعامل Tabbio مع بياناتك',
      helpTitle: 'ساعد في تحسين Tabbio',
      helpDesc: 'لتحسين Tabbio، يتيح لنا هذا الخيار استخدام بياناتك لتقييم وتدريب وتحسين ميزات Tabbio ونماذج الذكاء الاصطناعي.',
      privacyTitle: 'وضع الخصوصية',
      privacyDesc: 'عند تفعيل وضع الخصوصية، لن يتم تخزين أي من بياناتك أو استخدامها لتدريب النماذج من قِبلنا أو أي طرف ثالث.',
    },
    cvHealth: {
      checkingTitle: 'جارٍ فحص سيرتك الذاتية',
      reportTitle: 'صحة السيرة',
      continue: 'متابعة',
      fixMyCv: 'أصلح سيرتي الذاتية',
      tryAgain: 'حاول مرة ثانية',
      continueWithout: 'المتابعة دون فحص',
      tryAnotherFile: 'جرّب ملفًا آخر',
      back: 'رجوع',
      agent: {
        fixing: 'جارٍ إصلاح ما وجدناه…',
        fixingContext: 'تبقى وظائفك وتواريخك وبيانات التواصل كما هي.',
        rechecking: 'جارٍ فحص سيرتك الذاتية الجديدة…',
        recheckingContext: 'نتيجتك الجديدة على وشك الظهور.',
        undoing: 'جارٍ إعادة نصك الأصلي…',
      },
      fixedUp: 'انتقلت سيرتك الذاتية من {{from}} إلى {{to}}.',
      fixedNow: 'تحصل سيرتك الذاتية الآن على {{score}}.',
      alreadyScores: 'تحصل سيرتك الذاتية بالفعل على {{score}}.',
      questionsLeft_zero: 'لا يوجد ما يحتاج إلى موافقتك.',
      questionsLeft_one: 'أمر واحد يحتاج إلى موافقتك. راجعه متى شئت في سيرتك الذاتية.',
      questionsLeft_two: 'أمران يحتاجان إلى موافقتك. راجعهما متى شئت في سيرتك الذاتية.',
      questionsLeft_few: '{{count}} أمور تحتاج إلى موافقتك. راجعها متى شئت في سيرتك الذاتية.',
      questionsLeft_many: '{{count}} أمرًا يحتاج إلى موافقتك. راجعها متى شئت في سيرتك الذاتية.',
      questionsLeft_other: '{{count}} أمر يحتاج إلى موافقتك. راجعها متى شئت في سيرتك الذاتية.',
      fixFailed: 'تعذّر إكمال إصلاح سيرتك الذاتية.',
    },
    chooseAI: {
      titleBase: 'اختر إلى أي مدى',
      titleAccent: 'تريد الوصول',
      subtitle: 'ابدأ مجانًا، أو افتح الأدوات التي تساعدك على التقديم أسرع والتميز.',
      proName: 'برو',
      plusName: 'بلس',
      freeName: 'مجاني',
      freePrice: 'مجاني',
      recommended: 'موصى به',
      poweredBy: 'الأنسب لـ',
      proFit: 'الأتمتة والباحثين المكثفين عن عمل',
      plusFit: 'الباحثين النشطين عن عمل',
      freeFit: 'البدء واستكشاف Tabbio',
      proFeat1: 'كل ما في بلس',
      proFeat2: 'أتمتة الوكيل المهني وفق جدولك',
      proFeat3: 'يجد الوظائف لك ويجهّزك للمقابلات',
      proFeat4: 'رؤى الرواتب ومعاينة مسؤولي التوظيف',
      proFeat5: 'أقوى ذكاء اصطناعي وذاكرة موسّعة و100,000 رصيد شهريًا',
      plusFeat1: 'كاتب سيرة بالذكاء الاصطناعي وسير مخصّصة ورسائل تعريف',
      plusFeat2: 'تعبئة تلقائية غير محدودة عبر SmartApply',
      plusFeat3: 'من شاهد ملفك، وتحليلات المشاهدات والمصادر',
      plusFeat4: 'علامة تجارية مخصّصة وتنزيل بأي صيغة',
      plusFeat5: '10,000 رصيد ذكاء اصطناعي شهريًا ومهارات مميزة وتطبيقات متصلة',
      freeFeat1: 'إنشاء سيرتك الذاتية واستيرادها وإدارتها',
      freeFeat2: 'رابط عام للسيرة وتصدير PDF و10 تعبئات تلقائية شهريًا',
      freeFeat3: '7 رسائل على الأقل يوميًا في المحادثة، مع صورة مجانية و3 ملفات و5 عمليات بحث على الويب',
      freeFeat4: 'تشغيل مهارة واحدة أسبوعيًا ومعاينة واحدة للوكيل المهني شهريًا',
      learnMore: 'اعرف المزيد',
      showLess: 'عرض أقل',
      upgrade: 'الترقية إلى {{name}} - {{price}}/شهر',
      continueFree: 'المتابعة بالخطة المجانية',
      continueFreeLink: 'المتابعة بالخطة المجانية الآن',
      cancelNote: 'يمكنك الإلغاء في أي وقت، لا رسوم للخطة المجانية',
      saveFailedTitle: 'تعذر حفظ اختيارك',
      saveFailedBody: 'يرجى المحاولة مرة أخرى قبل المتابعة.',
      checkoutFailedTitle: 'تعذر إتمام الدفع',
      checkoutFailed: 'تعذر بدء عملية الدفع. يرجى المحاولة مرة أخرى.',
      checkoutMissing: 'تعذر تأكيد عملية الدفع. يرجى اختيار خطة مرة أخرى.',
      checkoutNotConfirmed: 'لا يزال اشتراكك قيد التأكيد. يرجى المحاولة مرة أخرى.',
      checkoutWrongUser: 'عملية الدفع هذه مرتبطة بحساب مختلف.',
      title: 'كيف نكتب سيرتك؟',
      groupLabel: 'باقة كتابة السيرة',
      close: 'إغلاق',
      freeLabel: 'مجاني',
      freeDescription: 'أنشئ سيرتك وشاركها.',
      aiModel: 'نموذج الذكاء الاصطناعي',
      perMonth: '/ شهر',
      writing: {
        basic: 'كتابة أساسية',
        enhanced: 'كتابة محسّنة',
        advanced: 'كتابة متقدمة',
      },
      benefits: {
        plus: {
          moreAi: 'استخدام أكثر للذكاء الاصطناعي',
          connectTools: 'اربط أدواتك',
          insightsCustomization: 'إحصاءات وخيارات تخصيص أكثر',
        },
        pro: {
          everythingInPlus: 'كل مزايا \u2066Plus\u2069',
          nova: 'نوفا، مساعدك للوظائف',
          scheduled: 'بحث مجدول، وحدود أعلى',
        },
      },
      seeAllFeatures: 'شوف كل مزايا الباقات',
      continueWithTier: 'المتابعة مع \u2068{{tier}}\u2069',
      createFreeCv: 'جهّز سيرتي مجاناً',
      continueWithFree: 'المتابعة مجاناً',
      disclosurePaid: 'يتجدد شهرياً. تقدر تلغي بأي وقت.',
      disclosureFree: 'بدون بيانات دفع.',
    },
    cvInput: {
      title: 'استيراد سيرتك الذاتية',
      subtitle: 'سنستخرج بياناتك لتسريع العملية. يمكنك أيضاً تخطي هذه الخطوة وإدخال كل شيء يدوياً.',
      uploadPdf: 'رفع ملف PDF',
      uploadPdfDesc: 'اختر ملف PDF من جهازك',
      photoImage: 'صورة',
      photoImageDesc: 'التقط صورة أو اختر صورة لسيرتك الذاتية',
      pasteText: 'لصق نص',
      pasteTextDesc: 'انسخ والصق محتوى سيرتك الذاتية',
      textPlaceholder: 'الصق نص سيرتك الذاتية هنا...',
      extract: 'استخراج',
      minChars: '20 حرفاً على الأقل',
      pickFile: 'اختر ملف PDF',
      pickImage: 'اختر صورة',
    },
    personalInfo: {
      title: 'المعلومات الشخصية',
      subtitle: 'أخبرنا عن نفسك. ستظهر هذه المعلومات على ملفك الشخصي.',
      name: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      location: 'الموقع',
      headline: 'العنوان المهني',
      namePlaceholder: 'محمد أحمد',
      emailPlaceholder: 'mohammed@example.com',
      phonePlaceholder: '+971 50 000 0000',
      locationPlaceholder: 'دبي، الإمارات',
      headlinePlaceholder: 'مهندس برمجيات أول',
      nameRequired: 'الاسم مطلوب',
    },
    experience: {
      title: 'الخبرة العملية',
      titleBase: 'أضف',
      titleAccent: 'خبرتك',
      subtitle: 'النتائج أهم من المسميات الوظيفية',
      jobTitle: 'المسمى الوظيفي',
      company: 'الشركة',
      location: 'الموقع',
      startDate: 'تاريخ البدء',
      endDate: 'تاريخ الانتهاء',
      currentRole: 'أعمل هنا حالياً',
      addExperience: 'إضافة خبرة',
      remove: 'إزالة',
      titlePlaceholder: 'مهندس برمجيات',
      companyPlaceholder: 'شركة أكمي',
      locationPlaceholder: 'دبي، الإمارات',
      datePlaceholder: 'شهر/سنة',
    },
    education: {
      title: 'التعليم',
      titleBase: 'أضف',
      titleAccent: 'تعليمك',
      subtitle: 'أحدث شهادة أولاً، دائماً',
      institution: 'المؤسسة التعليمية',
      degree: 'الدرجة العلمية',
      field: 'مجال الدراسة',
      startDate: 'تاريخ البدء',
      endDate: 'تاريخ الانتهاء',
      addEducation: 'إضافة تعليم',
      remove: 'إزالة',
      institutionPlaceholder: 'جامعة دبي',
      degreePlaceholder: 'بكالوريوس علوم',
      fieldPlaceholder: 'علوم الحاسوب',
      datePlaceholder: 'شهر/سنة',
    },
    certifications: {
      title: 'الشهادات المهنية',
      titleBase: 'أضف',
      titleAccent: 'شهاداتك',
      subtitle: 'التراخيص والشهادات التي حصلت عليها',
      certName: 'اسم الشهادة',
      issuer: 'الجهة المانحة',
      issueDate: 'تاريخ الإصدار',
      expiryDate: 'تاريخ الانتهاء',
      addCertification: 'إضافة شهادة',
      remove: 'إزالة',
      namePlaceholder: 'مهندس حلول AWS',
      issuerPlaceholder: 'أمازون ويب سيرفيسز',
      datePlaceholder: 'شهر/سنة',
    },
    skills: {
      title: 'المهارات',
      titleBase: 'أضف',
      titleAccent: 'مهاراتك',
      subtitle: 'مقترحة بناءً على ملفك الشخصي',
      inputPlaceholder: 'اكتب مهارة ثم اضغط إضافة',
      add: 'إضافة',
      noSkills: 'لم تُضف أي مهارات بعد',
      searchPlaceholder: 'ابحث عن الأدوار أو المهارات',
      sectionExperience: 'الخبرة',
      sectionEducation: 'التعليم',
      sectionCertifications: 'التراخيص والشهادات',
      noLinkItems: 'أضف خبرة أو تعليمًا أولاً لربط مهاراتك.',
      otherCategory: 'مهارات',
      linkTitle: 'أين استخدمت هذه المهارة؟',
      roleAtCompany: '{{role}} في {{company}}',
      done: 'تم',
    },
    jobPreferences: {
      title: 'تفضيلات العمل',
      subtitle: 'أخبر تابيو بنوع الأدوار التي تريدها بعد ذلك.',
      titleBase: 'أضف',
      titleAccent: 'تفضيلات عملك',
    },
    matchYou: {
      title: 'ساعد جهات التوظيف',
      titleAccent: 'في إيجادك',
      subtitle: 'أضف ما تريد فقط. أنت دائماً المتحكم.',
      sections: {
        aboutYou: 'عنك',
        locationEligibility: 'الموقع والأهلية',
      },
      fields: {
        dateOfBirth: 'تاريخ الميلاد',
        gender: 'الجنس',
        nationalService: 'الخدمة الوطنية',
        maritalStatus: 'الحالة الاجتماعية',
        dependents: 'المعالون',
        nationality: 'الجنسية',
        residence: 'بلد الإقامة',
        visaResidency: 'التأشيرة / الإقامة',
      },
      options: {
        gender: {
          male: 'ذكر',
          female: 'أنثى',
          preferNot: 'أفضل عدم الإفصاح',
        },
        nationalService: {
          completed: 'مكتملة',
          inProgress: 'قيد التنفيذ',
          exempted: 'معفى',
          notApplicable: 'لا ينطبق',
        },
        maritalStatus: {
          single: 'أعزب',
          married: 'متزوج',
          divorced: 'مطلق',
          widowed: 'أرمل',
        },
        dependents: {
          none: 'لا يوجد',
          one: 'طفل واحد',
          two: 'طفلان',
          three: '٣ أطفال',
          fourPlus: '٤ أطفال أو أكثر',
          soleProvider: 'المعيل الوحيد للأسرة',
          supportingParents: 'إعالة الوالدين/كبار السن',
        },
        visaResidency: {
          citizen: 'مواطن',
          resident: 'تأشيرة إقامة',
          workPermit: 'تصريح عمل',
          visit: 'تأشيرة زيارة',
          golden: 'الإقامة الذهبية',
          student: 'تأشيرة طالب',
        },
      },
      selectPlaceholder: 'اختر',
      dateOfBirthPlaceholder: 'اختر التاريخ',
      nationalitySearch: 'ابحث عن دولة',
      footerCaption: 'مرئي لأصحاب العمل فقط.',
      privacy: 'الخصوصية',
      save: 'حفظ',
      saveFailed: 'تعذر الحفظ. حاول مرة أخرى.',
    },
    summary: {
      titleBase: 'أضف',
      titleAccent: 'ملخصك',
      subtitle: 'مقدمتك: والذكاء الاصطناعي يكتب المسودة',
    },
    languages: {
      titleBase: 'أضف',
      titleAccent: 'لغاتك',
      subtitle: 'اللغات التي تتحدثها وتقرؤها وتكتبها',
    },
    highlights: {
      titleBase: 'أضف',
      titleAccent: 'أبرز إنجازاتك',
      subtitle: 'أبرز لحظات مسيرتك المهنية',
    },
    username: {
      title: 'احجز اسم المستخدم',
      subtitle: 'سيكون هذا رابط ملفك الشخصي العام.',
      usernamePlaceholder: 'اسم المستخدم',
      preview: 'سيكون ملفك الشخصي على:',
      available: 'متاح',
      checking: 'جارٍ التحقق...',
      taken: 'مأخوذ بالفعل',
      reserved: 'غير متاح',
      invalidFormat: 'تنسيق غير صالح',
      formatRules: 'استخدم الأحرف والأرقام والشرطات. يجب أن يبدأ بحرف وينتهي بحرف أو رقم.',
      trySuggestion: 'جرّب: {{suggestion}}',
      useSuggestion: 'استخدم {{suggestion}}',
      checkFailed: 'تعذّر التحقق من التوفر: يمكنك المتابعة',
      tooShort: 'يجب أن يكون 3 أحرف على الأقل',
      invalidChars: 'أحرف صغيرة وأرقام فقط',
      required: 'اختر رابطاً للمتابعة',
    },
    complete: {
      title: 'أنت جاهز!',
      subtitle: 'ملفك الشخصي جاهز. ابدأ باستكشاف تابيو.',
      copyLink: 'نسخ الرابط',
      linkCopied: 'تم نسخ الرابط',
      companySubtitle: 'تم إعداد شركتك بنجاح. اختر خطوتك التالية في التوظيف.',
      profileLink: 'رابط ملفك الشخصي:',
      companyLink: 'رابط صفحة الوظائف:',
      goToTabbio: 'الذهاب إلى تابيو',
      exploreTabbio: 'البحث عن وظائف',
      continueFromPreview: 'متابعة',
      continueError: 'تعذّرت المتابعة. يرجى المحاولة مرة أخرى.',
      downloadShort: 'تنزيل',
      share: 'مشاركة',
      downloadCv: 'تحميل السيرة الذاتية',
      downloadingCv: 'جارٍ التحميل...',
      goCreateJob: 'إنهاء وإنشاء وظيفة',
      goFindCandidates: 'إنهاء والبحث عن مرشحين',
    },
    reviewCv: {
      title: 'أكمل سيرتك الذاتية',
      subtitle: 'اضغط على أي قسم لملئه. يمكنك التعديل في أي وقت.',
      add: 'إضافة',
      edit: 'تعديل',
      preview: 'معاينة سيرتي الذاتية',
      groups: {
        essentials: 'الأساسيات',
        boost: 'عزّز ملفك',
        match: 'احصل على فرص',
      },
      sections: {
        contact: { title: 'التواصل والروابط', subtitle: 'هاتفك وبريدك وروابطك' },
        experience: { title: 'الخبرة', subtitle: 'أدوارك وجهات عملك' },
        education: { title: 'التعليم', subtitle: 'المدارس والشهادات' },
        skills: { title: 'المهارات', subtitle: 'أضف مهاراتك' },
        summary: { title: 'الملخص المهني', subtitle: 'أضف مقدمة قصيرة' },
        highlights: { title: 'أبرز الإنجازات', subtitle: 'اعرض أهم نجاحاتك' },
        certifications: { title: 'الشهادات', subtitle: 'أضف شهاداتك' },
        jobPreferences: { title: 'تفضيلات العمل', subtitle: 'حدّد ما تبحث عنه' },
      },
    },
    continue: 'متابعة',
    profileSetup: {
      title: 'أعد ملفك الشخصي',
      subtitle: 'اختر اسماً. سيصبح رابطك.',
      nationality: 'الجنسية',
      nationalityPlaceholder: 'مثال: إماراتي، هندي، بريطاني',
      photoTitle: 'الصورة الشخصية',
      addPhoto: 'أضف صورة',
      uploadPhoto: 'رفع صورة',
      changePhoto: 'تغيير الصورة',
      removePhoto: 'إزالة',
      photoUploadFailed: 'تعذر رفع صورتك',
      saveFailedTitle: 'تعذر حفظ ملفك الشخصي',
      saveFailedBody: 'يرجى التحقق من اتصالك والمحاولة مرة أخرى.',
      authRequired: 'تعذر إكمال تسجيل الدخول. يرجى تسجيل الدخول مرة أخرى.',
      networkFailed: 'فشل طلب الشبكة. تحقق من اتصالك وحاول مرة أخرى.',
    },
    intent: {
      title: 'ما الذي يجلبك إلى هنا؟',
      subtitle: 'هذا يشكّل تجربتك',
      lookingForJob: 'أبحث عن وظيفة',
      lookingForJobDesc: 'أنشئ سيرتك الذاتية واكتشف الفرص',
      freelancer: 'مستقل',
      freelancerDesc: 'ابحث عن عملاء واعرض خدماتك',
      company: 'شركة',
      companyDesc: 'أنشئ صفحة وظائف شركتك ووظّف أفضل المواهب',
      buildingBrand: 'أبني علامتي الشخصية',
      buildingBrandDesc: 'أنشئ حضوراً مهنياً على الإنترنت',
      hiringTalent: 'أوظّف كفاءات',
      hiringTalentDesc: 'اعثر على أفضل المرشحين واستقطبهم',
    },
    companyInfo: {
      title: 'معلومات الشركة',
      subtitle: 'أعد صفحة الوظائف لشركتك بالمعلومات الأساسية.',
      steps: {
        counter: '{{current}} من {{total}}',
        identityTitle: 'أنشئ صفحة شركتك',
        identitySubtitle: 'ابدأ بالاسم الذي سيتعرّف عليه المرشحون.',
        detailsTitle: 'أخبرنا عن فريقك',
        detailsSubtitle: 'تساعد هذه التفاصيل المرشحين على فهم شركتك.',
        storyTitle: 'امنح صفحتك حضوراً',
        storySubtitle: 'أضف قصتك الآن، ويمكنك تحسين كل شيء لاحقاً.',
      },
      companyName: 'اسم الشركة *',
      companyNamePlaceholder: 'شركة أكمي',
      careerPageUrl: 'رابط صفحة الوظائف *',
      urlHint: 'سيكون هذا رابط صفحة الوظائف العامة الخاصة بك.',
      urlHintBeta: 'تم حجز هذا الرابط الآن. نشر صفحة الشركة العامة يبقى متوقفًا خلال النسخة التجريبية.',
      industry: 'القطاع *',
      industryPlaceholder: 'اختر القطاع',
      industryPickerTitle: 'القطاع',
      companySize: 'حجم الشركة *',
      companySizePlaceholder: 'اختر الحجم',
      companySizePickerTitle: 'حجم الشركة',
      location: 'الموقع *',
      locationPlaceholder: 'مثال: أبوظبي أو دبي',
      locationHint: 'أين يقع المقر الرئيسي لشركتك؟',
      website: 'الموقع الإلكتروني (اختياري)',
      logo: 'شعار الشركة',
      logoHint: 'أضف شعاراً لتكون صفحتك أكثر وضوحاً وتميّزاً.',
      uploadLogo: 'رفع الشعار',
      saveFailed: 'تعذر حفظ معلومات الشركة',
      saving: 'جارٍ الحفظ...',
      createPage: 'إنشاء صفحة الشركة',
      nextActionTitle: 'ما الذي تريد فعله أولاً؟',
      nextActionSubtitle: 'سننقلك إليه مباشرة بعد إكمال الإعداد.',
      nextActionCreateJob: 'إنشاء وظيفة',
      nextActionCreateJobDesc: 'انشر أول وظيفة وابدأ باستقبال الطلبات.',
      nextActionFindCandidate: 'البحث عن مرشحين',
      nextActionFindCandidateDesc: 'تصفح ملفات المرشحين وقم بترشيح الأنسب بسرعة.',
      nextActionChat: 'الذهاب إلى محادثة التوظيف',
      nextActionChatDesc: 'استخدم Tabbio AI لصياغة الوظائف وسير عمل التوظيف.',
    },
    hiringSetup: {
      title: 'أنشئ صفحة شركتك',
      subtitle: 'جهّز شركتك لبدء التوظيف على Tabbio.',
    },
    cvJourney: {
      or: 'أو',
      parseFailedTitle: 'فشل التحليل',
      resumeImportFailedTitle: 'فشل استيراد السيرة الذاتية',
      handoffUnavailableTitle: 'ارفع سيرتك الذاتية مرة أخرى',
      handoffUnavailableBody:
        'لم تصل سيرتك الذاتية من الموقع إلى التطبيق. ارفعها أو الصقها أدناه للمتابعة.',
      handoffAlreadyClaimedBody:
        'تم استيراد هذه السيرة الذاتية من قبل. ارفع سيرة ذاتية أو الصقها أدناه للمتابعة.',
      handoffClaimFailedBody:
        'لم نتمكن من نقل سيرتك الذاتية من الموقع. ارفعها أو الصقها أدناه للمتابعة.',
      cvHandoffClaimFailedTitle: 'تعذر فتح السيرة التي وصلتك',
      cvHandoffClaimFailedBody:
        'لم نتمكن من الوصول إلى السيرة التي وصلتك. يمكنك متابعة إنشاء سيرتك أدناه، وسنحاول فتح الدعوة مرة أخرى عند الانتهاء.',
      cvHandoffProfileNotUpdatedBody:
        'السيرة التي وصلتك محفوظة في حسابك. لم نتمكن من تعبئة ملفك الشخصي منها، فأنشئ سيرتك أدناه وستجد النسخة المحفوظة في انتظارك.',
      aiInputTitle: 'لنُنشئ سيرتك الذاتية',
      aiInputSubtitle: 'يستغرق ثوانٍ فقط.',
      pasteHere: 'ارفع سيرتك الذاتية أو الصقها، أو أخبرنا بما تفعله',
      linkUnsupported: 'لا يمكننا فتح الروابط. ارفع سيرتك الذاتية، أو انسخ نص ملفك الشخصي والصقه هنا.',
      extract: 'استخراج بالذكاء الاصطناعي',
      fillManually: 'أنشئ سيرتي يدوياً',
      hiringLink: 'توظّف؟ أنشئ صفحة شركة بدلاً من ذلك',
      parseFailed: 'تعذرت معالجة المدخلات. حاول مرة أخرى أو أملأها يدويًا.',
      moreDetailRequired: 'يرجى إضافة مزيد من التفاصيل',
      unsupportedFile: 'نوع الملف غير مدعوم. ارفع ملف PDF أو Word أو نص أو صورة.',
      fileTextUnreadable:
        'لم نتمكن من قراءة نص كافٍ من هذا الملف. جرّب ملف PDF أو Word نصيًا، أو الصق نص السيرة الذاتية.',
      parseIncomplete:
        'لم نعثر على خبرات عمل أو تعليم أو شهادات في هذه السيرة الذاتية، لذلك لم يتغير شيء. جرّب ملفًا آخر أو الصق نص السيرة الذاتية.',
      parseIncompleteReview:
        'لم نتمكن من قراءة جميع أقسام هذه السيرة الذاتية، لذلك لم يتغير شيء. النص الذي تمكنا من قراءته موجود أدناه: راجعه، وأضف ما ينقصه، ثم استخرجه مرة أخرى.',
      parseProviderUnavailable:
        'قارئ السيرة الذاتية غير متاح مؤقتًا، لذلك لم يتغير شيء. يرجى المحاولة مرة أخرى بعد بضع دقائق، أو لصق نص السيرة الذاتية.',
      handoffRetryLater:
        'سيرتك الذاتية المرفوعة محفوظة لفترة قصيرة. حاول مرة أخرى بعد بضع دقائق، أو ارفعها أدناه.',
      exactExtractionTitle: 'تم الاستيراد بدون الذكاء الاصطناعي',
      exactExtractionMessage:
        'كان كاتب الذكاء الاصطناعي غير متاح، لذلك استخدمنا التفاصيل الدقيقة من سيرتك الذاتية دون إعادة صياغتها. يمكنك مراجعتها وتحسينها في الخطوات التالية.',
      exactExtractionContinue: 'استخدام التفاصيل الدقيقة',
      exactExtractionCancel: 'ليس الآن',
      parseProgress: {
        reading: {
          title: 'قراءة السيرة الذاتية',
          detail: 'نحدد الأدوار والتعليم ومعلومات التواصل.',
        },
        extracting: {
          title: 'استخراج الخبرات',
          detail: 'نحوّل الخبرات إلى أقسام منظمة في الملف.',
        },
        enhancing: {
          title: 'تحسين الصياغة',
          detail: 'نصقل الملخص والمهارات والإنجازات.',
        },
        preparing: {
          title: 'تجهيز السيرة الذاتية',
          detail: 'نحضّر خطوة المراجعة التالية.',
        },
      },
      headerTitle: 'التواصل والروابط',
      headerSubtitle: 'كيف يمكن للناس التواصل معك؟',
      headerTitleBase: 'أضف',
      headerTitleAccent: 'جهات اتصال سيرتك',
      addressLabel: 'العنوان',
      linksSection: 'الروابط',
      tabbioLinkLabel: 'رابط Tabbio',
      contactSection: 'جهات اتصال السيرة',
      accountEmailLabel: 'البريد الإلكتروني للحساب',
      accountEmailUnavailable: 'غير متوفر',
      accountEmailHelper: 'هذا البريد تستخدمه لتسجيل الدخول. يبقى خاصًا ولا يمكن تعديله هنا.',
      cvEmailLabel: 'البريد الإلكتروني',
      cvEmailPlaceholder: 'email@example.com',
      cvEmailHelper: 'استخدم هذا البريد على السيرة الذاتية إذا أردت أن يتواصل الناس معك من خلاله. اتركه فارغًا لإخفاء البريد من السيرة.',
      phoneLabel: 'رقم الهاتف',
      phoneRequired: 'رقم الهاتف مطلوب.',
      phoneInvalid: 'أدخل رقم هاتف صحيحًا للدولة المحددة.',
      links: 'الروابط',
      emailVisibilityTitle: 'من يمكنه رؤية بريدك الإلكتروني',
      phoneVisibilityTitle: 'من يمكنه رؤية رقم هاتفك',
      learnVisibility: 'تعرّف على كيفية عمل الخصوصية',
      contactVisibility: {
        recommended: 'موصى به',
        employers: { title: 'أصحاب العمل فقط', subtitle: 'يظهر عند تنزيل سيرتك أو إرسالها' },
        hidden: { title: 'مخفي تماماً', subtitle: 'لا يظهر لأي أحد' },
        box: {
          bothEmployers: 'أنت وأصحاب العمل فقط يمكنكم رؤية بريدك ورقم هاتفك',
          bothHidden: 'بريدك ورقم هاتفك مخفيان عن الجميع',
          mixed: 'بريدك ورقم هاتفك لهما إعدادات خصوصية مختلفة',
        },
      },
      howContacts: {
        title: 'كيف تعمل جهات اتصالك',
        subtitle: 'بسيطة جداً. تبقى أنت المتحكم',
        private: { title: 'خاصة افتراضياً', desc: 'لا يظهر بريدك ورقم هاتفك أبداً على سيرتك العامة على الويب. أنت وأصحاب العمل فقط من يمكنكم رؤيتهما. يمكن لأي شخص آخر التواصل معك عبر رسالة Tabbio.' },
        link: { title: 'تُشارك عبر رابط خاص', desc: 'أرسل رابطاً واحداً فريداً يحمل جهات اتصالك، تماماً كسيرة عادية. أعد إنشاءه في أي وقت ويتوقف الرابط القديم فوراً.' },
        download: { title: 'حمّلها كملف PDF', desc: 'صدّر سيرتك كملف PDF وشاركها في أي مكان. تتضمن تفاصيل التواصل، كأي سيرة عادية.' },
      },
    },
    visibility: {
      public: 'عام',
      employers: 'أصحاب العمل',
      private: 'خاص',
      hidden: 'مخفي',
      pickHint: 'اختر من يمكنه الرؤية',
      done: 'تم',
      whoSeesYouTitle: 'من يمكنه رؤيتك',
    },
  },

  roleSelect: {
    title: 'أنا...',
    seeker: {
      title: 'باحث عن عمل',
      description: 'أنشئ سيرتك الذاتية واعثر على الفرص',
    },
    employer: {
      title: 'صاحب عمل',
      description: 'اعثر على أفضل المواهب ووظّفها',
    },
  },

  profileSetup: {
    nameTitle: 'ما اسمك؟',
    nameSubtitle: 'هكذا سيراك الآخرون على Tabbio.',
    namePlaceholder: 'الاسم الكامل',
    nameRequired: 'نحتاج إلى اسمك للبدء.',
    usernameTitle: 'اختر اسم مستخدم',
    usernameSubtitle: 'سيكون هذا رابطك الفريد على Tabbio.',
    usernamePlaceholder: 'اسم المستخدم',
    usernameInvalid: 'أحرف إنجليزية صغيرة وأرقام فقط، من 3 إلى 30 حرفاً.',
    passwordTitle: 'عيّن كلمة مرور',
    passwordSubtitle: 'اختر كلمة مرور قوية لحماية حسابك.',
    socialLinks: 'روابط التواصل الاجتماعي',
    add: 'إضافة',
    continue: 'متابعة',
  },
} as const;
